import { Fragment } from 'react'
import classNames from 'classnames'

import Image from '../ui/Image/Image'
import styles from './CareerLayout.module.scss'
import separator from '../../assets/images/right-angular-arrow.svg'

function CareerBreadcrumb({ categories = [] }) {
  return (
    <div className={styles.breadcrumbsContainer}>
      {categories.map((cat, index) => (
        <Fragment key={cat}>
          <label className={classNames(styles.label)}>{cat}</label>
          {index < categories.length - 1 && (
            <Image
              src={separator}
              alt="Separator"
              className={classNames(styles.separator)}
            />
          )}
        </Fragment>
      ))}
    </div>
  )
}

export default CareerBreadcrumb
